export const SIDEBAR_OPEN_THRESHOLD = 1500;
export const ADMIN_TABS_THRESHOLD = 1290;

export const REPORT_TABS_THRESHOLD = 900;
export const JOB_LISTING_TABS_THRESHOLD = 1150;
export const JOB_TABS_THRESHOLD = 850;
export const CALENDAR_THRESHOLD = 850;
